import { rewriteNumberToFixed } from '@zoom/billing-common';
import get from 'lodash-es/get';

if (!get(window.campaignFlags, 'FORBIDDEN_REWRITE_PROTOTYPE')) {
  rewriteNumberToFixed();
}
